// extracted by mini-css-extract-plugin
export var cardSelected = "_fs-2";
export var image = "_fs-1";
export var table = "_fs-0";